<div class="auth-language-wrapper" *ngIf="showLanguageSelector">
  <div class="dropdown" dropdown #dropdown="bs-dropdown" [insideClick]="false">
    <button type="button" class="btn auth-lang-btn d-flex align-items-center" dropdownToggle
            id="auth-page-language-dropdown">
      <i class="bx bx-globe font-size-18 me-1 text-primary"></i>
      <span class="lang-text font-size-14 fw-medium">{{ selectedLanguage }}</span>
      <i class="mdi mdi-chevron-down ms-1 text-muted"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-end shadow-lg border-0 py-1" *dropdownMenu>
      <a class="dropdown-item d-flex align-items-center py-2 px-3" style="cursor: pointer;"
         *ngFor="let language of languages" [class.active]="language.name === selectedLanguage"
         (click)="changeLanguage(language); $event.preventDefault();">
         <!-- <span class="flag-icon me-2">{{language.code === 'en'?'GB':'FR'}}</span> -->
         <span>{{language.name}}</span>
        <i *ngIf="language.name === selectedLanguage" class="mdi mdi-check text-primary ms-auto"></i>
      </a>
    </div>
  </div>
</div>